import { Datadog } from "./Datadog"

export { useDatadog } from "./hooks/useDatadog"
export type { DatadogAppConfig } from "./types"
export * from "./helpers/graphql-request/middleware"
export * from "./helpers/error"

// eslint-disable-next-line import/no-default-export
export default Datadog
